import React, { useState, useEffect } from "react";
import { getEnvelopeSenderList, checkMyFilesEnabled } from "../../../../services/CommonService";
import { useNavigate } from "react-router-dom";
import Utils from "../../../../utils";
import Pagination from "react-js-pagination";
import DeleteEnvelope from "./DeleteEnvelope";
import TransferEnvelope from "./TransferEnvelope";
import CopyEnvelope from "./CopyEnvelope";
import useDocumentCounts from "./useDocumentCounts";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import "../../../../assets/ManageSleeve.css";

const lengths = Utils.tableShowLengths();

// Helper function to highlight search terms
const highlightSearchTerm = (text, searchTerm) => {
  if (!searchTerm || !text) return text;

  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? (
      <mark key={index} className="search-highlight" style={{
        backgroundColor: '#ffeb3b',
        padding: '0 2px',
        borderRadius: '2px',
        fontWeight: 'bold'
      }}>
        {part}
      </mark>
    ) : part
  );
};

function DraftManageEnvelope() {
  const navigate = useNavigate();
  const userData = Utils.loginUserData();
  const userEmail = userData?.email || "";
  const [myFilesEnabled, setMyFilesEnabled] = useState(null);

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [senderList, setSenderList] = useState([]);
  const [dataParams, setDataParams] = useState({
    limit: lengths[0],
    page: 1,
    status_id: 0,
    search: "",
    sender_id: "",
    order_column: 'created_at',
    order_by: false,
    is_effect: false
  });
  const [deleteEnvelope, setDeleteEnvelope] = useState({ id: 0, name: '' });
  const [copyEnvelope, setCopyEnvelope] = useState(0);
  const [dropdownVisible, setDropdownVisible] = useState(null);

  // Hook for fetching data
  const {
    counts: { totalInProgress, totalDraft, totalCompleted, totalFiles, totalMyFile },
    envelopeList,
    envelopeProcess,
    loading,
  } = useDocumentCounts({ userEmail, selectedUserId, dataParams });

  // Fetch sender list
  useEffect(() => {
    getEnvelopeSenderList()
      .then(response => {
        const senderData = response.data.data;
        setSenderList(senderData);
        if (senderData.length > 0) {
          setSelectedUserId(senderData[0].id);
        }
      })
      .catch(err => {
        console.error("Error fetching sender list:", err);
      });
    // Check MyFiles enabled status
    checkMyFilesEnabled({})
      .then(res => {
        if (res.data && typeof res.data.data?.myfiles_enabled !== 'undefined') {
          setMyFilesEnabled(res.data.data.myfiles_enabled);
        } else {
          setMyFilesEnabled(false);
        }
      })
      .catch(err => {
        setMyFilesEnabled(false);
      });
  }, []);

  // Handle data parameter changes
  const handleData = (e, type) => {
    let params = { ...dataParams };
    if (type === 'pagination') {
      params.page = e;
    } else if (type === 'sender') {
      params.sender_id = e.target.value;
    } else if (type === 'search') {
      params.search = e.target.value;
    } else if (type === 'limit') {
      params.limit = parseInt(e.target.value);
    }
    setDataParams(params);
  };

  // Handle sort
  const handleCreateSort = (column) => {
    let params = { ...dataParams };
    params.order_column = column;
    params.order_by = !params.order_by;
    params.page = 1;
    setDataParams(params);
  };

  // Navigation handlers
  const onEditEnvelope = (data) => {
    const route = data.is_smart_sleeve
      ? '/client-portal/sleeve/edit-smart/' + data.uuid + '/' + data.current_step
      : '/client-portal/sleeve/edit/' + data.uuid + '/' + data.current_step;
    navigate(route);
  };

  const onCopyEnvelope = (data) => {
    setCopyEnvelope(data.id);
  };

  const onDeleteEnvelope = (data) => {
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  const onTransferEnvelope = (data) => {
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  // Handle dropdown toggle
  const handleDropdownToggle = (id, visible) => {
    if (visible) {
      setDropdownVisible(id);
    } else {
      setDropdownVisible(null);
    }
  };

  return (
    <>

      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <section className="section-bg-color min-height-sleeve sleeve-spacing wrapper-sleeve">
        <div className="custom_container">
          {/* Tabs */}
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="table_header_wrap">
              <div
                className="nav nav-tabs mt-0 pb-0 wrap_left flexWrap"
                id="nav-tab"
                role="tablist"
              >
                <button
                  className="nav-link mb-3"
                  onClick={(e) => navigate("/manage")}
                  type="button"
                  role="tab"
                  aria-selected="true"
                >
                  In Progress <span>({totalInProgress})</span>
                </button>
                <button
                  className="nav-link mb-3 active"
                  onClick={(e) => navigate("/manage/draft")}
                  type="button"
                  role="tab"
                  aria-selected="true"
                >
                  Draft <span>({totalDraft})</span>
                </button>
                <button
                  className="nav-link  mb-3"
                  onClick={(e) => navigate("/manage/completed")}
                  type="button"
                  role="tab"
                  aria-selected="true"
                >
                  Completed <span>({totalCompleted})</span>
                </button>
                <button
                  className="nav-link mb-3 d-flex"
                  onClick={(e) => navigate("/manage/files")}
                  type="button"
                  role="tab"
                  aria-selected="ture"
                >
                  Sleeves Files
                </button>
                {/* My Files Button Logic */}
                {myFilesEnabled && (
                  <button className="nav-link mb-3 d-flex" onClick={(e) => navigate('/manage/my-files')}
                    type="button" role="tab" aria-selected="true" >
                    My Files
                  </button>
                )}
              </div>
            </div>
            {/* Filters */}
            <div className="filters-container">
              <div className="search-box mb-3">
                <i className="bi bi-search"></i>
                <input
                  type="text"
                  value={dataParams.search}
                  onChange={(e) => handleData(e, 'search')}
                  placeholder="Search Sleeves"
                />
              </div>
              {/* Only show user selection dropdown when there are multiple users */}
              {senderList.length > 1 && (
                <select
                  className="filter-select mb-3"
                  value={dataParams.sender_id}
                  onChange={(e) => handleData(e, 'sender')}
                  title="Select a user to filter sleeves"
                >
                  <option value="">All Users</option>
                  {senderList.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.first_name + " " + item.last_name}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </div>

          {/* Table */}
          <div className="table-container table-responsive">
            <table className="table-modern">
              <thead>
                <tr>
                  <th onClick={() => handleCreateSort('created_at')}>
                    Created
                    <i className={`bi ms-2 ${dataParams.order_column === 'created_at' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th onClick={() => handleCreateSort('envelope_name')}>
                    Sleeves Name
                    <i className={`bi ms-2 ${dataParams.order_column === 'envelope_name' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th onClick={() => handleCreateSort('recipient_names')}>
                    Recipients
                    <i className={`bi ms-2 ${dataParams.order_column === 'recipient_names' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th onClick={() => handleCreateSort('due_date')}>
                    Due Date
                    <i className={`bi ms-2 ${dataParams.order_column === 'due_date' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th onClick={() => handleCreateSort('sender_name')}>
                    User
                    <i className={`bi ms-2 ${dataParams.order_column === 'sender_name' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th className="table-header-center"><i className="bi bi-three-dots-vertical" /></th>
                </tr>
              </thead>
              <tbody>
                {envelopeList.map((item, index) => (
                  <tr key={index} className={item.is_smart_sleeve ? 'smart-sleeve-row' : ''}>
                    <td>{item.created_at}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <span
                          onClick={() => onEditEnvelope(item)}
                          className="fw-bold text_blue cursor-pointer"
                          title="Click to edit sleeve"
                        >
                          {highlightSearchTerm(item.envelope_name, dataParams.search)}
                        </span>
                        {item.is_smart_sleeve && (
                          <span
                            className="smart-sleeve-badge"
                            title="Smart Sleeve"
                          >
                            <i className="bi bi-lightning-fill"></i>Smart
                          </span>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex flex-column">
                        {item.recipient_names.map((recipient, r) => (
                          <span key={r} className="mb-1">{highlightSearchTerm(recipient, dataParams.search)}</span>
                        ))}
                      </div>
                    </td>
                    <td>
                      {item.due_date ? (
                        <span className={new Date(item.due_date) < new Date() ? 'text-danger' : ''}>
                          {item.due_date}
                        </span>
                      ) : (
                        <span className="text-muted">No due date</span>
                      )}
                    </td>
                    <td>{highlightSearchTerm(item.sender_name, dataParams.search)}</td>
                    <td className="table-header-center">
                      <div className="sleeve-dropdown">
                        {(() => {
                          const menu = (
                            <Menu className="custom-rc-dropdown-menu">
                              <MenuItem key="edit" className="custom-rc-dropdown-item" onClick={() => onEditEnvelope(item)}>
                                <i className="bi bi-pencil-square" /> Edit Sleeve
                              </MenuItem>
                              {!item.is_smart_sleeve && (
                                <MenuItem key="duplicate" className="custom-rc-dropdown-item" data-bs-toggle="modal"
                                  data-bs-target="#CopyEnvelope" onClick={() => onCopyEnvelope(item)}>
                                  <i className="bi bi-files" /> Duplicate Sleeve
                                </MenuItem>
                              )}
                              <MenuItem key="transfer" className="custom-rc-dropdown-item" data-bs-toggle="modal"
                                data-bs-target="#transferEnvelope" onClick={() => onTransferEnvelope(item)}>
                                <i className="bi bi-arrow-left-right" /> Transfer Sleeve
                              </MenuItem>
                              <MenuItem key="delete" className="custom-rc-dropdown-item-delete custom-rc-dropdown-item" data-bs-toggle="modal"
                                data-bs-target="#DeleteEnvelope" onClick={() => onDeleteEnvelope(item)}>
                                <i className="bi bi-trash" /> Delete Sleeve
                              </MenuItem>
                            </Menu>
                          );
                          return (
                            <Dropdown
                              trigger={["click"]}
                              overlay={menu}
                              animation="slide-up"
                              placement="bottomRight"
                            >
                              <button className="dots-button">
                                <i className="bi bi-three-dots-vertical"></i>
                              </button>
                            </Dropdown>
                          );
                        })()}
                      </div>
                    </td>
                  </tr>
                ))}

                {envelopeList.length === 0 && (
                  <tr>
                    <td colSpan={6}>
                      <div className="no-data">
                        <i className="bi bi-inbox"></i>
                        <p>{envelopeProcess}</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {parseInt(totalDraft) > dataParams.limit && (
            <div className="table_footer_wrap">
              <div className="d-flex align-items-center mb-4">
                <span className="me-2 text-white">Show</span>
                <select className="form-select" value={dataParams.limit} style={{ width: "80px" }}
                  onChange={(e) => handleData(e, 'limit')} aria-label="Default select example">
                  {lengths && lengths.map((item, i) => <option value={item} key={i}>{item}</option>)}
                </select>
              </div>

              <div className="pagination mb-4">
                <Pagination
                  activePage={dataParams.page}
                  itemsCountPerPage={dataParams.limit}
                  totalItemsCount={envelopeList.length ? parseInt(totalDraft) : 0}
                  pageRangeDisplayed={5}
                  onChange={(e) => handleData(e, 'pagination')}
                />
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Modals */}
      <DeleteEnvelope
        deleteEnvelope={deleteEnvelope}
        setDeleteEnvelope={setDeleteEnvelope}
        setLoading={() => { }}
        dataParams={dataParams}
        setDataParams={setDataParams}
      />

      <TransferEnvelope
        deleteEnvelope={deleteEnvelope}
        setDeleteEnvelope={setDeleteEnvelope}
        senderList={senderList}
        setLoading={() => { }}
        dataParams={dataParams}
        setDataParams={setDataParams}
      />

      <CopyEnvelope
        copyEnvelope={copyEnvelope}
        setCopyEnvelope={setCopyEnvelope}
        setLoading={() => { }}
      />
    </>
  );
}

export default DraftManageEnvelope;